import styled from 'styled-components';

const Text = styled.span`
  color: ${({ theme }) => theme.text.tableVulnName};
  text-transform: ${(props) => (props.capitalize ? 'capitalize' : 'none')};
`;

export default Text;
